import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import {
  getHeaderAndNavigationTypography,
  getButtonBackgroundColor,
  getButtonBackgroundHoverColor
} from 'styles/helpers/getThemeStyles';

const HeaderAndNavigationTypography = styled(Typography)(({ theme }) => {
  let hoverStyles = {};
  let color = 'initial';

  const fontStyles = getHeaderAndNavigationTypography(theme);
  color = getButtonBackgroundColor(theme);

  hoverStyles = {
    color: getButtonBackgroundHoverColor(theme)
  };

  return {
    ...fontStyles,
    color,
    '&:hover': {
      ...hoverStyles
    }
  };
});

export default HeaderAndNavigationTypography;
